import api from '../../components/api'
import { Division } from './division'

export const getDivisions = async (): Promise<Division[]> => {
  const { data } = await api.get('/web/divisions')
  return data
}

export const updateDivision = async (division: Division): Promise<void> => {
  await api.post('/web/divisions', division)
}

export const deleteDivision = async (id: number): Promise<void> => {
  await api.delete(`/web/divisions/${id}`)
}

export type DivisionGroup = {
  groupName: string
}

export const getDivisionGroups = async (): Promise<DivisionGroup[]> => {
  const { data } = await api.get('/divisions/groups')
  return data
}
